<label [for]="identifier">
  <input type="checkbox" [formControl]="control" [id]="identifier">
  <span
    class="svg-wrapper"
    [class.active]="control.value"
    [inlineSVG]="'/assets/svg/vector.svg'"></span>
  {{ label }}
</label>
